<template>
    <div class="profile-content" :key="this.$route.params.username">
        <header class="profile-content__header">
            <profile-header :username="this.$route.params.username"></profile-header>
        </header>
        <v-tabs :key="this.$route.params.username" color="red accent-4" centered v-model="model">
            <v-tab v-for="(tab, i) in tabs" :to="'/' + $route.params.username + tab.link" exact :key="'profile-tab-'+i" :replace="tab.replace">{{tab.title}}</v-tab>
        </v-tabs>
        <div class="primary">
            <!-- list-routers -->
            <router-view></router-view>
        </div>
        <!-- Dialog routers -->
        <router-view name="dialog"></router-view>
        <!-- Bottom bar for mobile -->
        <v-bottom-navigation app fixed v-if="!isDesktop && !editOptions" v-model="activeBarBtnMob">
            <v-btn text :to="`/${profile.username}/rate/`" replace color="textLinks" class="subtitle-2 text-capitalize">
                <v-icon>mdi-thumb-up</v-icon> Rate {{profile.username}}
            </v-btn>
        </v-bottom-navigation>
    </div>
</template>
<script>
import profileHeader from "@/components/profile/profile-header.vue"
import {
    CLEAR_PROFILE_POST_LIST
} from "@/store/mutations.type"
export default {
    data: () => ({
        model: 'profile-model',
        activeBarBtnMob: 1
    }),

    components: {
        'profile-header': profileHeader,
    },

    computed: {
        profile() {
            return this.$store.state.profile.activeProfile
        },

        editOptions() {
            return this.user.id === this.profile.id
        },

        tabs() {
            if (this.user.id === this.profile.id) {
                return [{
                    title: 'Posts',
                    link: '/',
                    replace: true
                }, 
                {
                    title: 'Saved',
                    link: '/saved/',
                    replace: true
                } 
                // {
                //     title: 'Tagged',
                //     link: '/tagged/',
                //     replace: true
                // }
                ]
            } else {
                return [{
                    title: 'Posts',
                    link: '/',
                    replace: true
                }, 
                // {
                //     title: 'Tagged',
                //     link: '/tagged/',
                //     replace: true
                // }
                ]
            }
        }
    },

    watch: {
        '$route.params.username'() {
            this.$store.commit(CLEAR_PROFILE_POST_LIST)
        }
    }
}
</script>